/*
 * Sel·Terre wishlist — localStorage based, no app, no login required.
 * - Heart toggles (product cards + product page) save/remove by product handle.
 * - Header icon shows a live count.
 * - The Wishlist page (#wishlist-grid) is rendered from saved handles.
 */
(function () {
  var KEY = 'selterre:wishlist';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }
  function write(list) { localStorage.setItem(KEY, JSON.stringify(list)); }
  function has(handle) { return read().indexOf(handle) !== -1; }
  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) { list.push(handle); } else { list.splice(i, 1); }
    write(list);
  }

  function updateCount() {
    var count = read().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      var span = el.querySelector('span');
      if (span) { span.textContent = count; } else { el.textContent = count; }
      el.hidden = count === 0;
    });
  }

  function syncButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-wishlist-handle');
      var active = has(handle);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      var add = btn.querySelector('[data-wishlist-label-add]');
      var rem = btn.querySelector('[data-wishlist-label-remove]');
      if (add && rem) { add.hidden = active; rem.hidden = !active; }
      var label = active ? 'Remove from wishlist' : 'Add to wishlist';
      btn.setAttribute('aria-label', label);
      btn.setAttribute('title', label);
    });
  }

  function formatMoney(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2); }
  }

  function baseUrl() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root.replace(/\/$/, '');
  }

  function ensureGrid() {
    if (document.getElementById('wishlist-grid')) { return true; }
    var path = window.location.pathname.replace(/\/+$/, '');
    if (!/\/pages\/wishlist$/.test(path)) { return false; }
    var main = document.getElementById('MainContent') || document.querySelector('main') || document.body;

    // Hide the default page-template title/body — we render our own, collection-style.
    var defaultTitle = main.querySelector('.main-page-title');
    if (defaultTitle) {
      var container = defaultTitle.closest('.page-width') || defaultTitle.parentNode;
      if (container) { container.style.display = 'none'; }
    }

    var wrap = document.createElement('div');
    wrap.className = 'wishlist-page page-width';
    wrap.innerHTML =
      '<h1 class="wishlist-page__title">Wishlist</h1>' +
      '<div id="wishlist-empty" class="wishlist-empty" hidden>' +
        '<p>Your wishlist is empty.</p>' +
        '<a href="/collections/all" class="button">Start shopping</a>' +
      '</div>' +
      '<div id="wishlist-grid" class="wishlist-grid" hidden></div>';
    main.appendChild(wrap);
    return true;
  }

  function renderWishlistPage() {
    if (!ensureGrid()) { return; }
    var grid = document.getElementById('wishlist-grid');
    if (!grid) { return; }
    var empty = document.getElementById('wishlist-empty');
    var handles = read();

    if (!handles.length) {
      grid.innerHTML = '';
      grid.hidden = true;
      if (empty) { empty.hidden = false; }
      return;
    }
    if (empty) { empty.hidden = true; }
    grid.hidden = false;
    grid.innerHTML = '';

    var base = baseUrl();
    handles.forEach(function (handle) {
      fetch(base + '/products/' + handle + '.js')
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (p) {
          if (!p) { return; }
          var img = p.featured_image || (p.images && p.images[0]) || '';
          var imgUrl = img ? (img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=600') : '';
          var card = document.createElement('div');
          card.className = 'wishlist-card';
          card.innerHTML =
            '<a class="wishlist-card__link" href="' + base + '/products/' + handle + '">' +
              (imgUrl ? '<img class="wishlist-card__image" src="' + imgUrl + '" alt="" loading="lazy">' : '') +
              '<span class="wishlist-card__info">' +
                '<span class="wishlist-card__title"></span>' +
                '<span class="wishlist-card__price"></span>' +
              '</span>' +
            '</a>' +
            '<button type="button" class="wishlist-card__remove" data-wishlist-toggle data-wishlist-handle="' + handle + '">Remove</button>';
          card.querySelector('.wishlist-card__title').textContent = p.title || '';
          card.querySelector('.wishlist-card__price').textContent = formatMoney(p.price);
          grid.appendChild(card);
          syncButtons();
        })
        .catch(function () {});
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-wishlist-toggle]') : null;

    // Fallback: card overlay (card__heading a::after) can intercept clicks even
    // when the heart button has a higher z-index. Check by click coordinates.
    if (!btn) {
      var allBtns = document.querySelectorAll('[data-wishlist-toggle]');
      var x = e.clientX, y = e.clientY;
      for (var i = 0; i < allBtns.length; i++) {
        var rect = allBtns[i].getBoundingClientRect();
        if (x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom) {
          btn = allBtns[i];
          break;
        }
      }
    }

    if (!btn) { return; }
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-wishlist-handle');
    if (!handle) { return; }
    toggle(handle);
    syncButtons();
    updateCount();
    renderWishlistPage();
  }, true); // capture phase — fires before the card link's bubble handler

  document.addEventListener('DOMContentLoaded', function () {
    updateCount();
    syncButtons();
    renderWishlistPage();
  });

  window.addEventListener('storage', function (e) {
    if (e.key === KEY) { updateCount(); syncButtons(); renderWishlistPage(); }
  });
})();
